import '@onereach/styles/main-v3.css';

import i18n from '@/i18n';
import router from '@/router';
import { createApp } from 'vue';

import AppRoot from './AppRoot.vue';
import createPinia from './stores';
import SentryApi from '@/sentry';

const app = createApp(AppRoot);

app.use(i18n);
app.use(createPinia());
app.use(router);


SentryApi.init(app, router);

export default app;
